import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { ReviewSnippet } from '../domain/entities/ReviewSnippet';
import { IReviewSnippetApiResult, ReviewSnippetApiSdk } from '../../api/ReviewSnippetApiSdk';
import {
    DEFAULT_ANSWERED_QUESTIONS,
    DEFAULT_AVERAGE_RATING,
    DEFAULT_REVIEW_COUNT
} from '../constants/PowerReviews';

export interface IReviewSnippetResult {
    [key: string]: IReviewSnippets;
}

export interface IReviewSnippets {
    [key: string]: ReviewSnippet;
}

export class ReviewSnippetRepository {
    private reviewSnippetApiSdk: ReviewSnippetApiSdk;
    private reviewSnippetResult: IReviewSnippetResult = {};

    constructor() {
        this.reviewSnippetApiSdk = diContainer.get(serviceNames.reviewSnippetApiSdk);
    }

    public async getReviewSnippet(pageIds: string[]) {
        const paramString = pageIds.join();
        const resultKey = Object.keys(this.reviewSnippetResult).find(key => key === paramString);
        if (!resultKey) {
            await this.loadReviewSnippetData(pageIds);
        }

        return this.reviewSnippetResult[paramString];
    }

    private async loadReviewSnippetData(pageIds: string[]) {
        const data = await this.reviewSnippetApiSdk.getReviewSnippet(pageIds);
        this.setReviewSnippetResult(data, pageIds);
    }

    private setReviewSnippetResult(data: IReviewSnippetApiResult[], pageIds: string[]) {
        const paramString = pageIds.join();
        this.reviewSnippetResult[paramString] = this.preprocessReviewSnippetResult(data, pageIds);
    }

    // API returns nothing if IDs don't have reviews.
    // Here, default values are getting assigned to the IDs which have no values
    private preprocessReviewSnippetResult(data: IReviewSnippetApiResult[], pageIds: string[]) {
        return pageIds.reduce((acc, pageId) => {
            const pageIdStr = pageId.toString();
            const resultData = data.find(result => result.page_id === pageIdStr);
            const reviewSnippetResultData = resultData || this.getDefaultResult(pageId);
            const reviewSnippet = ReviewSnippet.fromJson(reviewSnippetResultData);

            return { ...acc, [reviewSnippet.pageId]: reviewSnippet };
        }, {});
    }

    private getDefaultResult(pageId: string): IReviewSnippetApiResult {
        return {
            page_id: pageId,
            rollup: {
                average_rating: DEFAULT_AVERAGE_RATING,
                review_count: DEFAULT_REVIEW_COUNT,
                answered_questions: DEFAULT_ANSWERED_QUESTIONS
            }
        };
    }
}
